export enum ServerTypeEnum {
    Dev = 'dev',
    Test = 'test',
    Prod = 'prod',
    Prodch = 'prodch',
}
